import { render, staticRenderFns } from "./EditFichaLocalApp.vue?vue&type=template&id=4b55bf8e&scoped=true&"
import script from "./EditFichaLocalApp.vue?vue&type=script&lang=js&"
export * from "./EditFichaLocalApp.vue?vue&type=script&lang=js&"
import style0 from "./EditFichaLocalApp.vue?vue&type=style&index=0&id=4b55bf8e&scoped=true&lang=css&"
import style1 from "./EditFichaLocalApp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b55bf8e",
  null
  
)

export default component.exports